import { render, staticRenderFns } from "./SplitOverview.vue?vue&type=template&id=2ac79034&scoped=true&"
import script from "./SplitOverview.vue?vue&type=script&lang=js&"
export * from "./SplitOverview.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/document_edit.scss?vue&type=style&index=0&id=2ac79034&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac79034",
  null
  
)

export default component.exports